import React, { useState } from "react";
import Section from "../../components/Section";
import { pageTitle } from "../../helpers/PageTitle";
import { useSelector } from "react-redux";
import styled from "styled-components";
import toast from "react-hot-toast";
import SecondaryButton from "../../components/SecondaryButton";
import { createUserWithEmailAndPassword, sendEmailVerification, signInWithEmailAndPassword } from "firebase/auth";
import PageHeader from "../../components/PageHeader";
import InputField from "../../components/InputField";
import { auth } from "../../config/firebaseConfig";
import { BsEye } from "react-icons/bs";
import PasswordInputField from "../../components/PasswordField";
import axiosInstance from "../../utils/axiosInstance";
import { doctorRegistration, registerUser } from "../../constants/ApiConstants";
import { Link, useNavigate } from "react-router-dom";

export default function RegisterAsDoctor() {
  pageTitle("Register");

  const [loading, setLoading] = useState(false);
  const userId = useSelector((state) => state.appSlice.userData?.id);
  const [fullname, setFullname] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const handleFullNameChange = (e) => setFullname(e.target.value);
  const handleEmailChange = (e) => setEmail(e.target.value);
  const handlePasswordChange = (e) => setPassword(e.target.value);
  const handleConfirmPasswordChange = (e) => setConfirmPassword(e.target.value);

  const handleRegisterClick = async () => {
    if (fullname === "") {
      toast.error("Fullname is required");
      return;
    }
    if (email === "") {
      toast.error("Email is required");
      return;
    }
    if (password === "") {
      toast.error("Password is required");
      return;
    }

    if (password !== confirmPassword) {
      toast.error("Password and confirm password did not match.");
      return;
    }

    setLoading(true);

    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const response = await axiosInstance.post(doctorRegistration, {
        identity: userCredential.user.email,
        device_type: 1,
        device_token: "123456",
        name: fullname,
        login_type: 1,
        is_login: 0,
      });
      if (response.data.status) {
        await sendEmailVerification(userCredential.user);
        toast.success("Verification email has been sent.");
        navigate("/login-as-doctor");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      const errorCode = error.code;
      let errorMessage;

      switch (errorCode) {
        case "auth/email-already-in-use":
          errorMessage = "The email is already exist.";
          break;
        default:
          errorMessage = "An unexpected error occurred. Please try again.";
      }
      toast.error(errorMessage);
      console.error("Firebase login error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Wrapper>
      <Section topMd={60} topLg={120} topXl={110} bottomMd={200} bottomLg={150} bottomXl={110}>
        <div className="content-wrapper d-flex flex-column p-3 gap-1 justify-content-center">
          <div className="mx-auto col-md-4 g-2">
            {/* <img className="img-fluid w-25 h-25 m-3" src="/images/logo.svg" /> */}
            <PageHeader title={"Doctor Registration"} />
            <p className="fs-md text-grey2 p-2">Fill your details to begin your digital healthcare journey. Connect with doctors and easily book appointments.</p>
            <InputField label={"Fullname"} value={fullname} onChange={handleFullNameChange} placeholder={"Enter Fullname"} />
            <InputField label={"Email"} value={email} onChange={handleEmailChange} placeholder={"Enter Email"} />
            <PasswordInputField label={"Password"} value={password} onChange={handlePasswordChange} placeholder={"Enter Password"} />
            <PasswordInputField label={"Re-type Password"} value={confirmPassword} onChange={handleConfirmPasswordChange} placeholder={"Enter Re-type Password"} />
            <SecondaryButton title={"Register"} className={"mt-3"} onClick={handleRegisterClick} loading={loading} />
            <div className="d-flex align-items center justify-content-center fs-normal text-grey2 mt-4 gap-2">
              New user?
              <Link to={"/login-as-doctor"} className="bg-transparent text-sprimary fw-medium">
                Login here
              </Link>
            </div>
            <button className="d-block bg-transparent text-sprimary fw-medium mt-3 mx-auto fs-md">Forgot password?</button>
          </div>
        </div>
      </Section>
    </Wrapper>
  );
}
const Wrapper = styled.div``;
